import { useEffect, useRef } from "react";
import "gridstack/dist/gridstack.min.css";
import { GridStack } from "gridstack";
import aiSlide from "../../assets/AI-slide.png";

export default function PuzzleGrid() {
  const gridRef = useRef(null);

  useEffect(() => {
    if (!gridRef.current) return;

    let grid;
    try {
      // Init GridStack on the existing markup
      grid = GridStack.init(
        {
          column: 8,
          cellHeight: 75,
          margin: 0,
          float: true,
          disableResize: true, // ok in recent versions
        },
        gridRef.current
      );
    } catch (e) {
      console.error("GridStack init failed:", e);
      return;
    }

    // CSS variables (optional)
    const root = document.documentElement;
    root.style.setProperty("--gs-column-width", "100px");
    root.style.setProperty("--gs-cell-height", "75px");
    root.style.setProperty("--gs-item-margin-left", "0px");
    root.style.setProperty("--gs-item-margin-right", "0px");
    root.style.setProperty("--gs-item-margin-top", "0px");
    root.style.setProperty("--gs-item-margin-bottom", "0px");

    // Shuffle background positions for 4x4 puzzle
    const positions = [];
    for (let row = 0; row < 4; row++) {
      for (let col = 0; col < 4; col++) {
        positions.push({ x: -100 * col, y: -75 * row });
      }
    }
    for (let i = positions.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [positions[i], positions[j]] = [positions[j], positions[i]];
    }

    // Apply background tiles
    const tiles = gridRef.current.querySelectorAll(".grid-stack-item-content");
    tiles.forEach((el, i) => {
      const pos = positions[i];
      el.style.backgroundImage = `url('${aiSlide}')`;
      el.style.backgroundSize = "400px 300px";
      el.style.backgroundPosition = `${pos.x}px ${pos.y}px`;
    });

    // Cleanup without deleting DOM nodes
    return () => {
      try {
        grid?.destroy(false);
      } catch (e) {
        console.warn("GridStack destroy warning:", e);
      }
    };
  }, []);

  return (
    <div className="grid-stack" ref={gridRef}>
      {/* Row 0 */}
      <div className="grid-stack-item" data-gs-x="2" data-gs-y="0" data-gs-w="1" data-gs-h="1">
        <div className="grid-stack-item-content tile"></div>
      </div>
      <div className="grid-stack-item" data-gs-x="3" data-gs-y="0" data-gs-w="1" data-gs-h="1">
        <div className="grid-stack-item-content tile"></div>
      </div>
      <div className="grid-stack-item" data-gs-x="4" data-gs-y="0" data-gs-w="1" data-gs-h="1">
        <div className="grid-stack-item-content tile"></div>
      </div>
      <div className="grid-stack-item" data-gs-x="5" data-gs-y="0" data-gs-w="1" data-gs-h="1">
        <div className="grid-stack-item-content tile"></div>
      </div>

      {/* Row 1 */}
      <div className="grid-stack-item" data-gs-x="1" data-gs-y="1" data-gs-w="1" data-gs-h="1">
        <div className="grid-stack-item-content tile"></div>
      </div>
      <div className="grid-stack-item" data-gs-x="2" data-gs-y="1" data-gs-w="1" data-gs-h="1">
        <div className="grid-stack-item-content tile"></div>
      </div>
      <div className="grid-stack-item" data-gs-x="3" data-gs-y="1" data-gs-w="1" data-gs-h="1">
        <div className="grid-stack-item-content tile"></div>
      </div>
      <div className="grid-stack-item" data-gs-x="4" data-gs-y="1" data-gs-w="1" data-gs-h="1">
        <div className="grid-stack-item-content tile"></div>
      </div>

      {/* Row 2 */}
      <div className="grid-stack-item" data-gs-x="3" data-gs-y="2" data-gs-w="1" data-gs-h="1">
        <div className="grid-stack-item-content tile"></div>
      </div>
      <div className="grid-stack-item" data-gs-x="4" data-gs-y="2" data-gs-w="1" data-gs-h="1">
        <div className="grid-stack-item-content tile"></div>
      </div>
      <div className="grid-stack-item" data-gs-x="5" data-gs-y="2" data-gs-w="1" data-gs-h="1">
        <div className="grid-stack-item-content tile"></div>
      </div>
      <div className="grid-stack-item" data-gs-x="6" data-gs-y="2" data-gs-w="1" data-gs-h="1">
        <div className="grid-stack-item-content tile"></div>
      </div>

      {/* Row 3 */}
      <div className="grid-stack-item" data-gs-x="2" data-gs-y="3" data-gs-w="1" data-gs-h="1">
        <div className="grid-stack-item-content tile"></div>
      </div>
      <div className="grid-stack-item" data-gs-x="3" data-gs-y="3" data-gs-w="1" data-gs-h="1">
        <div className="grid-stack-item-content tile"></div>
      </div>
      <div className="grid-stack-item" data-gs-x="4" data-gs-y="3" data-gs-w="1" data-gs-h="1">
        <div className="grid-stack-item-content tile"></div>
      </div>
      <div className="grid-stack-item" data-gs-x="5" data-gs-y="3" data-gs-w="1" data-gs-h="1">
        <div className="grid-stack-item-content tile"></div>
      </div>
    </div>
  );
}